export default __webpack_public_path__ + "static/media/screeningError.169570e3.png";